import React from "react";
import  { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import './classes/ManageDocTalks.css';
import SalespersonSidebar from "./SalespersonSidebar";
import { Helmet } from 'react-helmet';
import { useLocation,useNavigate,useSearchParams } from 'react-router-dom';
import Loading from './Loading';




const columns = [   
  {
    field: 'mentor_name',
    headerName: 'Title',
    cellClassName:'mentor_name_column',headerClassName:'mentor_name_header',
    flex:1,
    sortable: false,
    filterable: false, 
    renderCell: (params) => (
      <Link href={params.row.view_url}  rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.mentor_name}
      </Link>
    ),
  }, 
  {
    field: 'action',
    headerName: 'Action',
    cellClassName:'action_column',headerClassName:'action_header',
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Link href={params.row.edit_url}  rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.linkText || 'edit'}
      </Link>
    ),
  },
];





const ManageDocTalks =() =>{
  /* Pagination, filter config starts here */
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [isLoading, setIsLoading] = useState(true);
const app_url = configData.APP_URL;
const location  = useLocation();
 const successMessage = location.state?.message; // Access the message
 window.history.replaceState({}, '');

 
     useEffect(() => {
  
   const fetchData = async () => {
     try {
 
     } catch (err) {
       console.error("Failed to fetch data", err);
     } finally {
       setIsLoading(false);
     }
   };
 
   fetchData();
    window.scrollTo(0, 0);
 }, []);

  React.useEffect(() => {
    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
      const response = await fetch(app_url+'doctalk/managelist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
     // console.log("Type of totalRowCount:", typeof data.data.totalRowCount);
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  

    };

    fetchData();
  }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change




 
    return(
      <>
               {isLoading ? (
                    <Loading />
                  ) : (
        <div id="main">
            <div className="left"></div>
            <>
                <div className="center left-center">
                    <div className="manage-doctalk-container">
                      <Helmet><title>Manage Doc Talk Mentors</title></Helmet>
                        {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                        <div className="manage-doctalk-view-content">
                            <div>
                                <a href="/node/add/doc-talk-mentors">Add Doc Talk</a>
                            </div>
                          <table className="manage-doctalk-view-table">
                                <div style={{ width: '100%',marginTop:"20px" }}>
                                <DataGrid
                                rows={rows}
                                columns={columns}
                                rowCount={rowCount}
                                paginationMode="server"
                                sortingMode="server"
                                filterMode="server"
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                                sortModel={sortModel}
                                onSortModelChange={setSortModel}
                                filterModel={filterModel}
                                onFilterModelChange={setFilterModel}
                                pageSizeOptions={[5, 10, 25,50]}
                                getRowId={() => crypto.randomUUID()}
                                getRowHeight={() => 'auto'}
                                disableColumnFilter 
                                disableColumnResize={true}
                            />
                              </div>
                        </table>
                            
                        </div>

                    </div>

                </div>
        </>
        <div class="right">
            <SalespersonSidebar/>
        </div>
        </div>
       )}
    </>  
    );
};

export default ManageDocTalks;